import { vacancyGroupKey, type VacancyOption } from '../vacancyTypes';

/**
 * Autogenerate for the tag form: a random position from the LIVE feed of unposted vacant items,
 * and a random non-empty subset of its items ticked — the only values the server will accept.
 * Null when there is nothing left to post.
 */
export function sampleJobPostingTags(options: VacancyOption[]): { groupKey: string; itemIds: string[] } | null {
  if (options.length === 0) return null;

  const pick = options[Math.floor(Math.random() * options.length)];
  const groupKey = vacancyGroupKey(pick);
  const items = options.filter((o) => vacancyGroupKey(o) === groupKey);
  const shuffled = [...items].sort(() => Math.random() - 0.5);

  return { groupKey, itemIds: shuffled.slice(0, 1 + Math.floor(Math.random() * shuffled.length)).map((o) => o.id) };
}
